export default __webpack_public_path__ + "static/media/home-black.ecbf1699.svg";